import type React from 'react';

import { useInboxActions } from '../../../../hooks/settings/inboxes/useInboxActions';
import { useInboxes } from '../../../../hooks/settings/inboxes/useInboxes';
import InboxDataModal from './InboxDataModal';

export const EditInboxModal: React.FC = () => {
  const { editInbox } = useInboxActions();

  const { selectedInbox } = useInboxes();

  const onSubmit = async (inboxData: any) => {
    if (selectedInbox?.identifier) {
      editInbox(selectedInbox.identifier, inboxData);
    }
  };

  return (
    <InboxDataModal
      onSubmit={onSubmit}
      inboxData={{
        name: selectedInbox?.name,
      }}
    />
  );
};

export default EditInboxModal;
